export default "__VITE_ASSET__DNnExocW__"